<header class="top-header">
  <div class="header-container">
    <!-- Left side: Social media icons -->
    <div class="social-icons">
      <a href="https://www.facebook.com/Universities-of-Canada-in-Egypt-Library-111411353780198" class="social-icon" aria-label="Facebook" title="Facebook" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a href="https://x.com/UofCanada" class="social-icon" aria-label="X (Twitter)" title="X (Twitter)" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-x-twitter"></i>
      </a>
      <a href="https://www.instagram.com/uofcanadalibrary" class="social-icon" aria-label="Instagram" title="Instagram" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-instagram"></i>
      </a>
      <a href="https://www.youtube.com/c/uofcanada" class="social-icon" aria-label="YouTube" title="YouTube" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-youtube"></i>
      </a>
      <a href="https://www.linkedin.com/school/uofcanada/" class="social-icon" aria-label="LinkedIn" title="LinkedIn" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-linkedin-in"></i>
      </a>
    </div>

    <!-- Right side: Search and Authentication -->
    <div class="right-section">
      <div class="search-section">
        <ds-search-navbar></ds-search-navbar>
      </div>
      <div class="auth-section">
       <i class="fas fa-arrow-right-from-bracket ng-tns-c4155650836-8" style="font-weight: 900;color:#fff;margin-right: -9px;margin-left:15px;padding-top:5px;"></i> <ds-auth-nav-menu></ds-auth-nav-menu>
      </div>
    </div>
  </div>
</header>
